"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Tue Oct 16 2018
 */

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var Theme_1 = require("./Theme");
/**
 * Used to list theme attributes and the number of windows each theme is assigned to
 *
 * @author JMt
 */


var ThemesViewDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ThemesViewDTO, _DomainObject_1$Domai);

  /**
   * Creates new DTO for the main themes listing
   *
   * @param theme
   * @param windowCount number of windows that have this theme assigned
   */
  function ThemesViewDTO(theme) {
    var _this;

    var windowCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    _classCallCheck(this, ThemesViewDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ThemesViewDTO).call(this));
    _this.theme = theme;
    _this.windowCount = windowCount;
    return _this;
  }

  return ThemesViewDTO;
}(DomainObject_1.DomainObject);

exports.ThemesViewDTO = ThemesViewDTO;

ThemesViewDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(Theme_1.Theme.name);
  return {
    theme: builder.obj(Theme_1.Theme.name, Theme_1.Theme.schema, function (mat) {
      return new Theme_1.Theme(mat.id, mat.name, mat.description, mat.validFrom, mat.validTo);
    }),
    windowCount: builder.num('windowCount')
  };
}();